import { render, staticRenderFns } from "./EventRequirementsInput.vue?vue&type=template&id=c4df7b2e&lang=pug"
import script from "./EventRequirementsInput.vue?vue&type=script&lang=js"
export * from "./EventRequirementsInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports